import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { MenuIcon, ShoppingCartIcon, ClipboardListIcon, UserIcon, UsersIcon, CameraIcon, TrophyIcon, PartyPopperIcon, GlobeIcon, LogOutIcon } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
const Sidebar: React.FC = () => {
  const {
    user,
    logout
  } = useAuth();
  const {
    totalItems
  } = useCart();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  return <div className="fixed left-0 top-0 h-full w-64 bg-[#34495E] text-white flex flex-col" data-id="element-130">
      {/* Logo */}
      <div className="bg-[#E84118] p-4 flex items-center justify-center cursor-pointer" onClick={() => navigate('/')} data-id="element-131">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sgVxQ9YUevUSGke2gMG7SZ/logo.png" alt="Just Cheetah" className="h-8" data-id="element-132" />
      </div>
      {/* User info */}
      <div className="p-4 border-b border-gray-700 flex items-center" data-id="element-133">
        <div className="w-8 h-8 rounded-full bg-gray-300 text-gray-700 flex items-center justify-center mr-3" data-id="element-134">
          {user?.name?.charAt(0) || 'T'}
        </div>
        <span data-id="element-135">{user?.name || 'Terry Crews'}</span>
      </div>
      {/* Navigation */}
      <nav className="flex-1 py-4 overflow-y-auto" data-id="element-136">
        <div className="px-4 text-xs text-gray-400 uppercase mb-2" data-id="element-137">
          Order Food
        </div>
        <NavLink to="/" className={({
        isActive
      }) => `flex items-center px-4 py-3 ${isActive ? 'bg-gray-700' : 'hover:bg-gray-700'} transition-colors duration-200`} data-id="element-138">
          <MenuIcon className="mr-3" size={20} data-id="element-139" />
          <span data-id="element-140">Menu</span>
        </NavLink>
        <NavLink to="/cart" className={({
        isActive
      }) => `flex items-center px-4 py-3 ${isActive ? 'bg-gray-700' : 'hover:bg-gray-700'} relative transition-colors duration-200`} data-id="element-141">
          <ShoppingCartIcon className="mr-3" size={20} data-id="element-142" />
          <span data-id="element-143">My Cart</span>
          {totalItems > 0 && <span className="absolute right-4 bg-[#E84118] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-144">
              {totalItems}
            </span>}
        </NavLink>
        <NavLink to="/order/history" className={({
        isActive
      }) => `flex items-center px-4 py-3 ${isActive ? 'bg-gray-700' : 'hover:bg-gray-700'} transition-colors duration-200`} data-id="element-145">
          <ClipboardListIcon className="mr-3" size={20} data-id="element-146" />
          <span data-id="element-147">My Orders</span>
        </NavLink>
        <div className="px-4 text-xs text-gray-400 uppercase mt-6 mb-2" data-id="element-148">
          Social & Events
        </div>
        <NavLink to="/mystery-lunch" className={({
        isActive
      }) => `flex items-center px-4 py-3 ${isActive ? 'bg-gray-700' : 'hover:bg-gray-700'} transition-colors duration-200`} data-id="element-149">
          <UsersIcon className="mr-3" size={20} data-id="element-150" />
          <span data-id="element-151">Mystery Lunch</span>
        </NavLink>
        <NavLink to="/foodie-challenge" className={({
        isActive
      }) => `flex items-center px-4 py-3 ${isActive ? 'bg-gray-700' : 'hover:bg-gray-700'} transition-colors duration-200`} data-id="element-152">
          <CameraIcon className="mr-3" size={20} data-id="element-153" />
          <span data-id="element-154">Foodie Challenge</span>
        </NavLink>
        <NavLink to="/themed-lunches" className={({
        isActive
      }) => `flex items-center px-4 py-3 ${isActive ? 'bg-gray-700' : 'hover:bg-gray-700'} transition-colors duration-200`} data-id="element-155">
          <GlobeIcon className="mr-3" size={20} data-id="element-156" />
          <span data-id="element-157">Themed Lunches</span>
        </NavLink>
        <NavLink to="/party-planner" className={({
        isActive
      }) => `flex items-center px-4 py-3 ${isActive ? 'bg-gray-700' : 'hover:bg-gray-700'} transition-colors duration-200`} data-id="element-158">
          <PartyPopperIcon className="mr-3" size={20} data-id="element-159" />
          <span data-id="element-160">Party Planner</span>
        </NavLink>
        <NavLink to="/community" className={({
        isActive
      }) => `flex items-center px-4 py-3 ${isActive ? 'bg-gray-700' : 'hover:bg-gray-700'} transition-colors duration-200`} data-id="element-161">
          <GlobeIcon className="mr-3" size={20} data-id="element-162" />
          <span data-id="element-163">Community</span>
        </NavLink>
        <div className="px-4 text-xs text-gray-400 uppercase mt-6 mb-2" data-id="element-164">
          My Profile
        </div>
        <NavLink to="/food-passport" className={({
        isActive
      }) => `flex items-center px-4 py-3 ${isActive ? 'bg-gray-700' : 'hover:bg-gray-700'} transition-colors duration-200`} data-id="element-165">
          <TrophyIcon className="mr-3" size={20} data-id="element-166" />
          <span data-id="element-167">Food Passport</span>
        </NavLink>
        <NavLink to="/profile" className={({
        isActive
      }) => `flex items-center px-4 py-3 ${isActive ? 'bg-gray-700' : 'hover:bg-gray-700'} transition-colors duration-200`} data-id="element-168">
          <UserIcon className="mr-3" size={20} data-id="element-169" />
          <span data-id="element-170">My Profile</span>
        </NavLink>
      </nav>
      {/* Logout */}
      <div className="p-4 border-t border-gray-700" data-id="element-171">
        <button onClick={handleLogout} className="w-full text-left px-4 py-2 hover:bg-gray-700 rounded flex items-center transition-colors duration-200" aria-label="Logout" data-id="element-172">
          <LogOutIcon size={18} className="mr-3" data-id="element-173" />
          <span data-id="element-174">Logout</span>
        </button>
      </div>
    </div>;
};
export default Sidebar;